import React from "react";
import Legend from "../ui/typographic/legend";
import LayoutSection from "../../layouts/layoutSection";
import TitreSection from "../ui/typographic/titreSection";
import { Slider } from "../../svgIcons/animate/slider";
import { Phone } from "../../svgIcons/animate/phone";
import SousTitreText from "../ui/typographic/sousTitreText";
import { CloudUpload } from "../../svgIcons/animate/cloudUpload";
import { Clock } from "../../svgIcons/animate/clock";
import { Localisation } from "../../svgIcons/animate/localisation";
import { useInView } from "react-intersection-observer";

const GridTextArgs = ({ lineStep, content }) => {

  const args = content.argumentsContent;

  const argumentsNapsis = [
    {
      titre: "expérience",
      nombre: "20 ans",
      img: <Clock colorMain='#000' colorDetail='#808bef' size={40} />
    },
    {
      titre: "nombre d'agences en France",
      nombre: "8",
      img: <Localisation colorMain='#000' colorDetail='#808bef' size={40} />
    },
    {
      titre: "lignes téléphoniques mises en place",
      nombre: "60000",
      img: <Phone colorMain='#000' colorDetail='#808bef' size={40} />
    },
    {
      titre: "données hébergées dans nos datacenters",
      nombre: "5000 Go",
      img: <CloudUpload colorMain='#000' colorDetail='#808bef' size={40} />
    },
    {
      titre: "liens supervisés",
      nombre: "4200",
      img: <Slider colorMain='#000' colorDetail='#808bef' size={40} />
    },
  ]
  const { ref: titreRef, inView: titreIsVisible } = useInView({
    threshold: .5,
    triggerOnce: true
  });


  const { ref: argsRef, inView: argsIsVisible } = useInView({
    threshold: .5,
    triggerOnce: true
  });

  const { ref: divdRef, inView: divIsVisible } = useInView({
    threshold: .5,
    triggerOnce: true
  });


  const titre = content.titre

  return (

    <LayoutSection
      step={lineStep}
      type='grid-text-arg'
      extraclass='bg-white'
    >
      <div className="md:grid grid-cols-3 content-start gap-8">
        <div ref={divdRef} className="col-span-2 statement mb-16">
          <Legend
            inView={divIsVisible}
            content="notre savoir faire"
            reference={titreRef}
          />
          <TitreSection
            content={titre}
            size={4}
            inView={titreIsVisible}
            reference={titreRef}
          />
        </div>
        <div></div>
        <div className="row-start-2 row-span-2  md:pr-10">
          <span className="sous-titre text-base align-top underline ">Napsis en chiffres</span>
          <div ref={argsRef}>
            {
              Object.values(argumentsNapsis).map((el, index) => {
                return (
                  <div key={`stat${index}`} className="flex items-center justify-center p-4 border border-slate-200 rounded-2xl mt-2 keynumber-div">
                    <div className="basis-3/4">
                      <span className="block text-sm key leading-5">{el.titre}</span>
                      <span className="block text-lg font-medium">{el.nombre}</span>
                    </div>
                    <div className="basis-1/4 text-right ">
                      {el.img}
                    </div>
                  </div>
                )
              })
            }
          </div>
        </div>
        {
          Object.values(args).map((arg, index) => {
            return (
              <div key={`arg${index}`} className={`row-start-${arg.position} asset border-t border-solid pt-5 pb-8`}>
                <SousTitreText
                  index={index}
                  Titre={arg.titre}
                  Text={arg.description}
                  Reference={argsRef}
                  inView={argsIsVisible}
                />
              </div>
            )
          })
        }
      </div>
    </LayoutSection>
  )
}

export default GridTextArgs
